export const SHOW_SORT_OPTIONS = [
  { label: 'Most Recently Excluded', value: 'MostRecentlyExcluded' },
  { label: 'Sort by Name A-Z', value: 'SortByNameAZ' },
  { label: 'Sort by Name Z-A', value: 'SortByNameZA' },
  {
    label: 'Sort by Days Excluded this Term Least - Most',
    value: 'SortbyDaysExcludedTermLeastMost'
  },
  {
    label: 'Sort by Days Excluded this Term Most - Least',
    value: 'SortbyDaysExcludedTermMostLeast'
  }
];
